import {Component, inject} from '@angular/core';
import {ButtonComponent, InputComponent, ToastService} from "@components";
import {IconDirective, LockComponent, ProfileIconComponent} from "@icons";
import {TranslocoPipe, TranslocoService} from "@jsverse/transloco";
import {Router, RouterLink} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {AuthenticationService} from "@services";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";
import {CookieService} from "../../../components/cookie-policy-modal/cookie-policy-modal.component";

@Component({
  selector: 'wun-login',
  imports: [
    InputComponent,
    ProfileIconComponent,
    LockComponent,
    ButtonComponent,
    TranslocoPipe,
    RouterLink,
    FormsModule,
    IconDirective
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  private readonly toastService = inject(ToastService)
  private readonly authService = inject(AuthenticationService);
  private readonly router = inject(Router)
  private readonly translocoService = inject(TranslocoService);
  private readonly cookieService = inject(CookieService);

  login(username: string, password: string): void {
    this.authService.login(
      {
        username, password
      }
    )
      .pipe(catchError(d => {
        if (d.status === 401) {
          this.toastService.addMessage({
            severity: 'error',
            title: this.translocoService.translate('login.wrong_credentials')
          })
        }
        if (d.status === 403) {
          this.toastService.addMessage({
            severity: 'error',
            title: this.translocoService.translate('login.user_not_enabled')
          })
        }
        return throwError(() => d);
      }))
      .subscribe(d => {
        this.cookieService.login(username)
        if (d.data.roles?.find(f => f.role.name === 'ADMIN'))
          this.router.navigate(['/backoffice'])
        else
          this.router.navigate(['/'])
      })
  }
}
